import send from './send'
import arriveTimes from './arrive-times'

export default {
    namespaced: true,
    modules: {
        send,
        arriveTimes
    }
}